<template>
    <div class="body">

		<div style="width: 90%;margin: 0 auto;">
			<p class="font1" style="margin: 0 auto;padding-top: 8vh;text-align: justify;">学习，从不缺少热情，只差一份更好的路径！🔥
                我们根据你11月的学习 slogan 精选了这些课程，助你突破瓶颈，冲向新高度！</p>
			<ul style="margin: 0 auto;padding-top: 2vh;">
				<li v-for="(course, index) in sloganRecommend" :key="index">
                    <label>
                        <input type="checkbox" :value="course.Name" v-model="selectedCourses"/>
                        {{ course.Name }}
                    </label>
                </li>
			</ul>
		</div>
		
    </div>
</template>
  
<script>
export default {
    props: {
        ReportData: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            default: () => []
        }
    },
    data() {
		return {
			slogan:[],
            selectedCourses: [],
            sloganRecommend:[]
		}
    }, 
    watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) {
                this.$emit('update:selected', newVal);
            }
        }
    },
    mounted() {
        this.selectedCourses = [...this.selected];
    },
    created(){
		if(this.ReportData.sloganRecommend !== null){
			this.sloganRecommend=this.ReportData.sloganRecommend
            // console.log(this.slogan,'coc')
		}
    },
}
</script>
  
<style scoped>
.body {
	background: 
        url("../../assets/25November/logo.png") right  top  no-repeat,
        url("../../assets/25November/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}

ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}

li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    /* content: '\2022';
    color: #000; */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #d03327;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25November/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .font1{
    text-align: center;
  }
    .font2{
        font-size: 19px;
    }
}
</style>